var map = {
	"./about-us-banner-cn.webp": 1557,
	"./about-us-banner-m-cn.webp": 1558,
	"./about-us-banner-m-ms.webp": 1559,
	"./about-us-banner-m.webp": 1560,
	"./about-us-banner-ms.webp": 1561,
	"./about-us-banner.webp": 462,
	"./banner-01.jpg": 1562,
	"./banner-slot.jpg": 1563,
	"./bet-and-earn-banner-cn.webp": 1564,
	"./bet-and-earn-banner-indon.webp": 1565,
	"./bet-and-earn-banner-ms.webp": 1566,
	"./bet-and-earn-banner.webp": 1567,
	"./check-in-banner-cn.webp": 1568,
	"./check-in-banner-id.webp": 1569,
	"./check-in-banner-ms.webp": 1570,
	"./check-in-banner.webp": 1571,
	"./cny_2024-bm.webp": 1572,
	"./cny_2024-cn.webp": 1573,
	"./cny_2024.webp": 1574,
	"./epl-banner-cn.webp": 1575,
	"./epl-banner-indo.webp": 1576,
	"./epl-banner-ms.webp": 1577,
	"./epl-banner.webp": 1578,
	"./games-banners-cn.webp": 1579,
	"./games-banners-ms.webp": 1580,
	"./games-banners.webp": 1581,
	"./lb-m-banner-cn.webp": 1582,
	"./lb-m-banner.webp": 1583,
	"./leaderboard-banner-cn.webp": 1584,
	"./leaderboard-banner.webp": 1585,
	"./lottery-banner.webp": 1586,
	"./lottery-banners-cn.webp": 1587,
	"./lottery-banners-ms.webp": 1588,
	"./lottery-banners.webp": 1589,
	"./lucky-spin-banner-cn.webp": 1590,
	"./lucky-spin-banner-ms.webp": 1591,
	"./lucky-spin-banner.webp": 1592,
	"./p2p-banner.webp": 1593,
	"./p2p-banners-cn.webp": 1594,
	"./p2p-banners-ms.webp": 1595,
	"./p2p-banners.webp": 1596,
	"./premier-league-banner-cn.webp": 1597,
	"./premier-league-banner.webp": 1598,
	"./promo-vip-banner-cn.webp": 1599,
	"./promo-vip-banner-ms.webp": 1600,
	"./promo-vip-banner.webp": 1601,
	"./promos-banner-cn.webp": 1602,
	"./promos-banner-indon.webp": 1603,
	"./promos-banner-ms.webp": 1604,
	"./promos-banner.webp": 1605,
	"./promos-detail-banner.jpg": 1606,
	"./side-bar-banner.jpg": 1607,
	"./slot-banners-cn.webp": 1608,
	"./slot-banners-ms.webp": 1609,
	"./slot-banners.webp": 1610,
	"./speed-banners-cn.webp": 1611,
	"./speed-banners-ms.webp": 1612,
	"./speed-banners.webp": 1613,
	"./vip-banner-cn.webp": 1614,
	"./vip-banner-id.webp": 1615,
	"./vip-banner-m-cn.webp": 1616,
	"./vip-banner-m-ms.webp": 1617,
	"./vip-banner-m.webp": 1618,
	"./vip-banner-ms.webp": 1619,
	"./vip-banner.webp": 1620,
	"./vip-deposit-marathon-challenges-cn.webp": 1621,
	"./vip-deposit-marathon-challenges-ms.webp": 1622,
	"./vip-deposit-marathon-challenges.webp": 1623,
	"./winner-leaderboard-banner-cn.webp": 1624,
	"./winner-leaderboard-banner.webp": 1625,
	"./world-cup-banner-cn.webp": 1626,
	"./world-cup-banner.webp": 1627,
	"./world-cup-two-banner-cn.webp": 1628,
	"./world-cup-two-banner.webp": 1629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;